
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { VehicleReviveSteps, StepsJson } from '@/models/inventory/vehiclerevivesteps';
import { Base } from '@/components/common/base';
import {vehicleReviveSettingsService,vehicleReviveStepsService} from '@/shared';
import { ValidationRules } from '@/helper/enum';
import { VehicleReviveSettingsJson, VehicleReviveSettingsViewModel } from '@/models/inventory/vehiclerevivesettings';

    @Component({
        props: ['isDialog', 'addressDialog', 'methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
    })
    export default class VehicleReviveSettingsAddPage extends Base {
        public isDialog: boolean;
        public addressDialog: any;
        public form: any = {};
        public reviveSettingsFields: Array<VFields<any>> = [];
        public valid: boolean = true;
        public disableSubmitButton: boolean = false;
        public vehicleReviveSettings: VehicleReviveSettingsViewModel = {
        };
        public vehicleReviveSettingsJson: VehicleReviveSettingsJson = {};
        public vehicleSettingTypes: string[] = ['T2L', 'ADR'];
        public selectedIds: string[] = [];
        public stores: any[] = [];

        public isAddUpdateButton = true;
        public storeId: number = 0;

        public flags = {
            loading: false,
            deleteDialog: false,
        };

        public pagedVehicleReviveSteps: VehicleReviveSteps[] = [];
        public pagedStepsJson: StepsJson[] = [];
        public pagination = new PaginationModel('name');
        public vehicleTypeList: any[] = [{ key: '0', value: 'New' }, { key: '1', value: 'Used' }]; // [ 'New', 'Used' ]
        public vehicleType: string = '';
        public reconId: string = '';
        public id: string = '';
        public settingsId: string = '';
        public greenLimitHint: string = '';
        public yellowLimitHint: string = '';
        public redLimitHint: string = '';

        get trigger(): boolean {
            return this.$props.dialog;
        }
        set trigger(val) {
            this.$emit('closedialog', val);
        }
        public created(): void {
            this.setFields();
        }

        public beforeDestroy() {
            const buttons = [];
            this.$emit('updateToolBar', buttons);
        }
        public callMethod(methodName): void {
            if (methodName === 'backToList') {
                this.$router.push({ name: 'admin.vehiclerevivesettings.list', params: { stores: this.storeId.toString(), vehicletypes: this.vehicleType } });
            } else if (methodName === 'submit') {
                if (!this.vehicleReviveSettings.vehicleType || !this.vehicleReviveSettings.settingType || !this.isAddUpdateButton) {
                    this.showAlert(false, this.$t('vehicleReviveSettings.alertSelectVehicleTypeAndSettingType'));
                    this.resetMethodName(methodName);
                    return;
                }
                this.submitVehicleReviveSettings();
            }

            this.resetMethodName(methodName);
        }
        public resetMethodName(methodName): void {
            if (methodName !== '') {
                this.$emit('resetMethodName', methodName);
            }
        }
        public updateToolBar(): void {
            const buttons: any = [];
            buttons.push({ id: '0', type: 'button', title:  this.$parent.$t('vehicleReviveSettings.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$parent.$t('vehicleReviveSettings.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left' });
            this.$emit('updateToolBar', buttons);
        }
        public mounted() {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'vehicleReviveSettings');
            
            this.setFields();
            if (this.$route.params.id) {
                this.id = this.$route.params.id;
            }
            if (this.$route.params.storeId) {
                this.storeId = Number(this.$route.params.storeId);
            }
            if (this.$route.params.settingsId) {
                this.settingsId = this.$route.params.settingsId;
            }
            if (this.$route.params.vehicleType) {
                this.vehicleReviveSettings.vehicleType = this.$route.params.vehicleType;
            }

            // Toolbar
            this.updateToolBar();
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });

            this.vehicleType = this.vehicleReviveSettings.vehicleType;
            this.getVehicleReviveSteps();

            if (this.$route.params.id !== '0' && this.$route.params.settingsId !== '0') {
                this.getVehicleReviveSettingsById();
            }

        }

        public setFields(): void {
            this.reviveSettingsFields = [
                // Vehicle Type List
                {
                    key: 'vehicleType',
                    type: 'v-alynk-select',
                    required: true,
                    templateOptions: {
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.vehicleType') as string,
                        required: true,
                        items: this.vehicleTypeList,
                        text: 'value',
                        value: 'key',
                        disabled: true,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        altag: 'Vehicle Type',
                        rules:[
                            v => this.required('Vehicle Type',v)
                        ]
                    },
                },
                // Settings Type List
                {
                    key: 'settingType',
                    type: 'v-alynk-select',
                    required: true,
                    templateOptions: {
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.settingType') as string,
                        required: true,
                        items: this.vehicleSettingTypes,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        altag: 'Setting Type',
                        rules:[
                            v => this.required('Setting Type',v)
                        ]
                    },
                },
                // from Revive Step Id
                {
                    key: 'fromReviveStepId',
                    type: 'v-alynk-select',
                    required: false,
                    templateOptions: {
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.fromStepName') as string,
                        // multiple: true,
                        required: false,
                        items: this.pagedStepsJson,
                        text: 'name',
                        value: 'id',
                        disabled: false,
                        altag: 'From Step Name',
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        events: {
                            onChange: (items, value) => {
                                const obj = this.pagedStepsJson.find((x) => x.id === value);
                                this.vehicleReviveSettings.fromReviveStepName = obj.name;
                            },
                        },
                    },

                },
                // to Revive Step Id
                {
                    key: 'toReviveStepId',
                    type: 'v-alynk-select',
                    required: false,
                    templateOptions: {
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.toStepName') as string,
                        // multiple: true,
                        required: false,
                        items: this.pagedStepsJson,
                        text: 'name',
                        value: 'id',
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        events: {
                            onChange: (items, value) => {
                                const obj = this.pagedStepsJson.find((x) => x.id === value);
                                this.vehicleReviveSettings.toReviveStepName = obj.name;
                            },
                        },
                    },
                }
                // Goal
                , {
                    key: 'goal',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 3,
                        label:this.$t('vehicleReviveSettings.reviveSettingFields.goal') as string,
                        required: true,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        mask: '###',
                        events: {
                            onChange: (value) => {
                                this.vehicleReviveSettings.greenGoalLimit = value;
                                this.vehicleReviveSettings.yellowGoalLimit = value;
                                this.updateHint();
                            },
                        },
                        rules:[
                            v => this.required('Goal(In Days)',v)
                        ]
                    },
                }
                // Green Goal Limit
                , {
                    key: 'greenGoalLimit',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 3,
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.greenGoalLimit') as string,
                        required: true,
                        disabled: true,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        hint: this.greenLimitHint,
                        rules:[
                            v => this.required('Green Goal Limit(In Days)',v)
                        ]
                    },
                }
                // Yellow Goal Limit
                , {
                    key: 'yellowGoalLimit',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 3,
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.yellowGoalLimit') as string,
                        required: true,
                        disabled: true,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        mask: '###',
                        hint: this.yellowLimitHint,
                        rules:[
                            v => this.required('Yellow Goal Limit(In Days)',v)
                        ]
                    },
                }
                // Red Goal Limit
                , {
                    key: 'redGoalLimit',
                    type: 'v-alynk-text-field',
                    required: true,
                    templateOptions: {
                        counter: 3,
                        label: this.$t('vehicleReviveSettings.reviveSettingFields.redGoalLimit') as string,
                        required: true,
                        disabled: false,
                        elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
                        mask: '###',
                        hint: this.redLimitHint,
                        events: {
                            onChange: (items, value) => {
                                this.updateHint();
                            },
                        },
                        rules:[
                            v => this.required('Red Goal Limit(In Days)',v)
                        ]
                    },
                },
            ];
        }

        public async getVehicleReviveSettingsById(): Promise<void> {
            try {
                this.flags.loading = true;
                this.formlyShowSkeleton(this.reviveSettingsFields);
                const resp = await vehicleReviveSettingsService
                    .getVehicleReviveSettingsById(Number(this.id), this.storeId, this.settingsId);
                if (resp) {
                    const response = resp;
                    if (response) {
                        this.vehicleReviveSettings = response;
                        this.vehicleReviveSettings.vehicleType =
                            (this.vehicleReviveSettings.vehicleType === 'New') ? '0' : '1';
                        this.updateHint();
                    }
                }
            } finally {
                this.flags.loading = false;
                this.formlyHideSkeleton(this.reviveSettingsFields);
            }
        }

        public updateHint() {
            this.greenLimitHint = 'Green Limit is from 0 to ' + this.vehicleReviveSettings.greenGoalLimit;
            this.yellowLimitHint = 'Yellow Limit is from ' + (Number(this.vehicleReviveSettings.yellowGoalLimit) + 1) +
                ' to ' + this.vehicleReviveSettings.redGoalLimit;
            this.redLimitHint = 'Red Limit is above ' + Number(Number(this.vehicleReviveSettings.redGoalLimit) + 1);
            this.setFields();
        }

        public async getVehicleReviveSteps(): Promise<void> {
            try {
                this.flags.loading = true;
                this.formlyShowSkeleton(this.reviveSettingsFields, 'fromReviveStepId');
                this.formlyShowSkeleton(this.reviveSettingsFields, 'toReviveStepId');
                this.pagedVehicleReviveSteps = [];
                this.pagedStepsJson = [];
                const resp = await vehicleReviveStepsService.getVehicleReviveSteps(this.storeId, this.pagination);
                this.flags.loading = false;
                if (resp) {
                    this.pagedVehicleReviveSteps = resp.results;
                    if (this.pagedVehicleReviveSteps.length > 0) {
                        this.reconId = this.pagedVehicleReviveSteps[0].id.toString();
                    }

                    if (this.vehicleType && this.pagedVehicleReviveSteps.length > 0) {
                        this.pagedStepsJson = resp.results[0].stepsJson;
                        this.filterByVehicleType(this.vehicleType);
                        this.setFields();
                    }
                }
            } finally {
                this.flags.loading = false;
                this.formlyHideSkeleton(this.reviveSettingsFields, 'fromReviveStepId');
                this.formlyHideSkeleton(this.reviveSettingsFields, 'toReviveStepId');
            }
        }
        public filterByVehicleType(selectedVehicleType): void {
            if (this.pagedVehicleReviveSteps.length > 0) {
                this.pagedStepsJson = this.pagedVehicleReviveSteps[0].stepsJson.filter((m) => {
                    return m.type === ((selectedVehicleType === '0') ? 'New' : 'Used');
                });
            }
        }
        
        public validateVehicleReviveSettings(): Vue & { validate: () => boolean } {
            return this.$refs.vehicleReviveSettingsForm as Vue & { validate: () => boolean };
        }

        public async submitVehicleReviveSettings(): Promise<void> {
            if(this.validateVehicleReviveSettings().validate()){
                this.isAddUpdateButton = false;

                const data = this.vehicleReviveSettings;
                this.vehicleReviveSettings.id = Number(this.id);
                this.vehicleReviveSettings.storeId = this.storeId;
                this.vehicleReviveSettings.settingsId = this.settingsId;

                if (this.$route.params.settingsId && this.$route.params.settingsId !== '0') {
                    try {
                        this.disableSubmitButton = true;
                        this.$emit('update:progress', this.disableSubmitButton);
                        await vehicleReviveSettingsService.updateVehicleReviveSettings(this.vehicleReviveSettings);
                        this.showAlert(true, this.$t('vehicleReviveSettings.alertUpdateVehicleReviveSetting'));
                        this.backToList();
                        this.isAddUpdateButton = true;
                    } finally {
                        this.isAddUpdateButton = true;
                        this.disableSubmitButton = false;
                        this.$emit('update:progress', this.disableSubmitButton);
                    }
                } else {
                    try {
                        this.disableSubmitButton = true;
                        this.$emit('update:progress', this.disableSubmitButton);
                        await vehicleReviveSettingsService.addVehicleReviveSettings(this.vehicleReviveSettings);
                        this.showAlert(true, this.$t('vehicleReviveSettings.alertSaveVehicleReviveSetting'));
                        this.backToList();
                        this.isAddUpdateButton = true;
                    } finally {
                        this.isAddUpdateButton = true;
                        this.disableSubmitButton = false;
                        this.$emit('update:progress', this.disableSubmitButton);
                    }
                }
            }
        }

        public backToList() {
            if (this.isDialog) {
                this.trigger = false;
                this.vehicleReviveSettings = {};
            } else {
                this.$router.push({
                    name: 'admin.vehiclerevivesettings.list',
                    params: {
                        storeId: this.storeId.toString(),
                        vehicleType: this.vehicleType,
                    },
                });
            }
        }

    }
